
import { required, email } from 'vuelidate/lib/validators'

// TODO: Turn into config
const roleOptions = [{
  value: 'eindgebruiker',
  text: 'Alleen kijken'
}, {
  value: 'gemeente-gebruiker',
  text: 'Gemeente - Medewerker'
}, {
  value: 'gemeente-beheerder',
  text: 'Gemeente - Beheerder'
}, {
  value: 'beheerder',
  text: 'EV Consult - Beheerder'
}]
const organisationOptions = [{
  value: 'evconsult',
  text: 'EV Consult'
}, {
  value: 'dordrecht',
  text: 'Dordrecht'
}, {
  value: 'harderwijk',
  text: 'Harderwijk'
}, {
  value: 'krimpenaandenijssel',
  text: 'Krimpen aan den IJssel'
}, {
  value: 'lansingerland',
  text: 'Lansingerland'
}, {
  value: 'nissewaard',
  text: 'Nissewaard'
}, {
  value: 'pijnackernootdorp',
  text: 'Pijnacker-Nootdorp'
}, {
  value: 'sudwestfryslan',
  text: 'Sudwest-Fryslan'
}, {
  value: 'wijdemeren',
  text: 'Wijdemeren'
}]

export const EditUserFields = {
  name: {
    label: 'Contactpersoon',
    type: 'text',
    placeholder: '',
    value: '',
    validationRules: {
      required
    },
    disabled: false
  },
  role: {
    label: 'Rol / rechten',
    type: 'select',
    value: null,
    validationRules: {
      required
    },
    disabled: false,
    options: roleOptions,
  },
  organisation: {
    label: 'Gemeente',
    type: 'select',
    value: null,
    validationRules: {
      required
    },
    disabled: false,
    options: organisationOptions
  },
  active: {
    label: 'Actief',
    type: 'select',
    value: 'yes',
    validationRules: {
      required
    },
    disabled: false,
    options: [{
      value: 'yes',
      text: 'Ja'
    }, {
      value: 'no',
      text: 'nee'
    }]
  }
}

export const NewUserFields = {
  name: {
    label: 'Contactpersoon',
    type: 'text',
    placeholder: '',
    value: '',
    validationRules: {
      required
    },
    disabled: false
  },
  email: {
    label: "E-mail",
    type: "email",
    placeholder: "naam@bedrijf.nl",
    value: '',
    validationRules: {
      required, email
    },
    disabled: false
  },
  password: {
    label: "Wachtwoord",
    type: "password",
    autocomplete: "new-password",
    value: '*****',
    validationRules: {
      required
    },
    disabled: false
  },
  // Additional fields compared to regular registration
  role: {
    label: 'Rol / rechten',
    type: 'select',
    value: null,
    validationRules: {
      required
    },
    disabled: false,
    options: roleOptions,
  },
  organisation: {
    label: 'Gemeente',
    type: 'select',
    value: null,
    validationRules: {
      required
    },
    disabled: false,
    options: organisationOptions
  }
}
